function refrescarTrasTabulacionAcondicionamiento() {
    const inputIdReporte = document.getElementById('idReporteAcondicionamiento');
    const idReporte = inputIdReporte ? inputIdReporte.value : '';

    if (idReporte && typeof window.actualizarModalReporteAcondicionamiento === 'function') {
        window.actualizarModalReporteAcondicionamiento(idReporte);
    }

    const params = new URLSearchParams(window.location.search);
    if (typeof window.actualizarTablaAcondicionamientoPeriodo === 'function') {
        window.actualizarTablaAcondicionamientoPeriodo(params.get('mes'), params.get('año'));
    }
    if (typeof window.actualizarZonaTrabajo === 'function') {
        window.actualizarZonaTrabajo();
    }
}

function asegurarIdReporteAcondicionamiento(formulario) {
    const inputFormulario = formulario.querySelector('[name="idEncabezadoReporteAcondicionamiento"]');
    const inputReporteActivo = document.getElementById('idReporteAcondicionamiento');
    const idReporteActivo = inputReporteActivo ? inputReporteActivo.value : '';

    if (inputFormulario && !inputFormulario.value && idReporteActivo) {
        inputFormulario.value = idReporteActivo;
    }
}

function obtenerEnteroTabulacionAcondicionamiento(input) {
    if (!input) return 0;

    const valor = String(input.value || '').replace(/,/g, '').replace(/\D/g, '');
    if (valor === '') return 0;

    const numero = parseInt(valor, 10);
    return isNaN(numero) ? 0 : numero;
}

function formatearEnteroTabulacionAcondicionamiento(numero) {
    return new Intl.NumberFormat('en-US').format(numero);
}

function actualizarCantidadTrabajadaTabulacionAcondicionamiento(formulario) {
    if (!formulario) return;

    const inputUnidadesBuenas = formulario.querySelector('[name="unidadesBuenas"]');
    const inputUnidadesOtraDisposicion = formulario.querySelector('[name="unidadesOtraDisposicion"]');
    const inputUnidadesMalas = formulario.querySelector('[name="unidadesMalas"]');
    const inputCantidadTrabajada = formulario.querySelector('[name="cantidadTrabajada"]');

    if (!inputCantidadTrabajada) return;

    const total =
        obtenerEnteroTabulacionAcondicionamiento(inputUnidadesBuenas) +
        obtenerEnteroTabulacionAcondicionamiento(inputUnidadesOtraDisposicion) +
        obtenerEnteroTabulacionAcondicionamiento(inputUnidadesMalas);

    inputCantidadTrabajada.value = formatearEnteroTabulacionAcondicionamiento(total);
}

window.actualizarCantidadTrabajadaTabulacionAcondicionamiento = actualizarCantidadTrabajadaTabulacionAcondicionamiento;

document.addEventListener('input', function (e) {
    const formulario = e.target.closest('#formAgregarTabulacionAcondicionamiento, #formEditarTabulacionAcondicionamiento');
    if (!formulario) return;

    if (
        e.target.name === 'unidadesBuenas' ||
        e.target.name === 'unidadesOtraDisposicion' ||
        e.target.name === 'unidadesMalas'
    ) {
        actualizarCantidadTrabajadaTabulacionAcondicionamiento(formulario);
    }
});

document.addEventListener('click', function (e) {
    const btnEditar = e.target.closest('.btnEditarTabulacionAcondicionamiento');
    const btnAgregar = e.target.closest('#btnAgregarTabulacionAcondicionamiento');

    if (!btnEditar && !btnAgregar) return;

    setTimeout(function () {
        const idFormulario = btnEditar ? 'formEditarTabulacionAcondicionamiento' : 'formAgregarTabulacionAcondicionamiento';
        const formulario = document.getElementById(idFormulario);
        actualizarCantidadTrabajadaTabulacionAcondicionamiento(formulario);
    }, 0);
});

function manejarSubmitTabulacionAcondicionamiento(idFormulario, idBoton, urlEndpoint, mensajeExito) {
    document.addEventListener('submit', async function (e) {
        if (e.target.id !== idFormulario) return;

        e.preventDefault();

        const formulario = e.target;
        const modalPadre = formulario.closest('.modal');
        const btnSubmit = formulario.querySelector('#' + idBoton);
        const spinner = formulario.querySelector('#spinner');

        if (idFormulario !== 'formEliminarTabulacionAcondicionamiento' && !formulario.checkValidity()) {
            formulario.reportValidity();
            return;
        }

        if (btnSubmit) btnSubmit.disabled = true;
        if (spinner) spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(function (input) {
            input.classList.remove('inputRojo');
        });

        try {
            asegurarIdReporteAcondicionamiento(formulario);
            if (idFormulario !== 'formEliminarTabulacionAcondicionamiento') {
                actualizarCantidadTrabajadaTabulacionAcondicionamiento(formulario);
            }
            const formData = new FormData(formulario);

            const respuesta = await fetch(urlEndpoint, {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            const json = await respuesta.json();

            if (!respuesta.ok || !json || !json.result) {
                if (typeof lanzarAlerta === 'function') lanzarAlerta('Error al procesar la solicitud.', 'alerta-roja');
                return;
            }

            const resultado = json.result;

            if (resultado.hayErrores) {
                if (Array.isArray(resultado.errores)) {
                    resultado.errores.forEach(function (error) {
                        if (typeof lanzarAlerta === 'function') {
                            lanzarAlerta(error.mensaje || 'Error de validación.', error.clase || 'alerta-roja');
                        }
                        if (error.campo) {
                            const campo = formulario.querySelector('[name="' + error.campo + '"]');
                            if (campo) campo.classList.add('inputRojo');
                        }
                    });
                }
                return;
            }

            formulario.reset();
            if (modalPadre) modalPadre.classList.remove('modal--show');

            refrescarTrasTabulacionAcondicionamiento();

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta(mensajeExito, 'alerta-verde');
            }

        } catch (error) {
            console.error('Error:', error);
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');
            } else {
                alert('Error crítico al procesar la solicitud.');
            }
        } finally {
            if (btnSubmit) btnSubmit.disabled = false;
            if (spinner) spinner.style.display = 'none';
        }
    });
}

manejarSubmitTabulacionAcondicionamiento('formAgregarTabulacionAcondicionamiento', 'btnAgregarTabulacionAcondicionamientoSubmit', '/api/acondicionamiento/detalle/crear', 'Registro guardado con éxito.');
manejarSubmitTabulacionAcondicionamiento('formEditarTabulacionAcondicionamiento', 'btnEditarTabulacionAcondicionamientoSubmit', '/api/acondicionamiento/detalle/actualizar', 'Registro actualizado con éxito.');
manejarSubmitTabulacionAcondicionamiento('formEliminarTabulacionAcondicionamiento', 'btnEliminarTabulacionAcondicionamiento', '/api/acondicionamiento/detalle/eliminar', 'Registro eliminado con éxito.');
